import React, { useEffect, useState } from "react";
import Tds from "./Tds"; 
import "./tbody.css";
import { useSelector } from "react-redux";

const Tbodys = ({ data = [], columnConfig, onAudioHandler }) => {
  const pageSize = useSelector((state) => state.operationHome.table.pageSize);
  const [emptyRowsCount, setEmptyRowsCount] = useState(0);

  useEffect(() => {
    // console.log("Tbodys Data Check:", data); // Helpful for debugging
    const cnt =
      pageSize - data?.length > 0 ? Math.min(pageSize, 20) - data?.length : 0;
    setEmptyRowsCount(cnt);
  }, [data, pageSize]);

  if (!data || data.length === 0) {
    return (
      <tbody>
        <tr className="table-row no-results-row">
          <td colSpan={columnConfig.length} className="no-results-cell">
            No results found
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      {data.map((row, rowIndex) => (
        <tr className="table-row" key={rowIndex}>
          {columnConfig.map((col) => {
            // Get value from data using the key defined in config (e.g., FeedbackStatus)
            const cellValue = row[col.dataColoumn] ?? "";

            // 1. Handling ReferralType (Your existing logic)
            if (col.id === "ReferralType") {
              return (
                <td
                  key={col.id}
                  className={`${col.className || ""} ellipsis-cell`}
                  style={{ maxWidth: col.columnWidth }}
                  title={cellValue}
                >
                  {cellValue}
                </td>
              );
            }

            // 2. Handling FeedbackStatus (FIX FOR YOUR ISSUE)
            // If the column is meant for FeedbackStatus, ensure boolean false shows text
            if (col.dataColoumn === "FeedbackStatus") {
               return (
                <td key={col.id} className="ellipsis-cell-feed">
                   {/* If false, show 'Pending', if true, show 'Completed' */}
                   {row.FeedbackStatus ? "Yes" : "No"}
                </td>
               )
            }

            // 3. Default to Tds component for all other columns
            return (
              <Tds
                key={col.id}
                eachTableData={row}
                eachColoumnConfig={col}
                onAudioHandler={onAudioHandler}
              />
            );
          })}
        </tr>
      ))}
      
      {/* Empty Rows Logic */}
      {Array.from({ length: emptyRowsCount }).map((_, index) => (
        <tr className="table-row empty-row" key={`empty-${index}`}>
          {columnConfig.map((col) => (
            <td key={col.id} className="table-head--width">
              <div className="empty-col">---</div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
};

export default Tbodys;